export default __webpack_public_path__ + "static/media/ML-car.6cf97b12.webp";